import Vue from 'vue'
import { config, library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faBars } from '@fortawesome/pro-regular-svg-icons'
import { faTimes } from '@fortawesome/pro-light-svg-icons'

config.autoAddCss = true

library.add(faBars)
library.add(faTimes)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
